module.exports = __webpack_public_path__ + "assets/subscription-header-logo.e960dcdf.svg";